import axios from "axios";
export default axios.create({
     // baseURL:"http://localhost:5000"
     baseURL:"https://jain-tirthankara-vm8bf.ondigitalocean.app"
     
})